module.exports = __webpack_public_path__ + "media/images/badge-inkjet-22c730740bbe1a6c3472b10bfd29167a.svg";